import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Datepicker from "components/forms/inputs/datepicker";
import Checkbox from "components/forms/inputs/checkbox";
import { LocaleString } from "models/locale";
import FormEmailRows from "components/forms/form-email-block";
import { useListUser } from "stores/hooks/list-user";

interface ApproveModalFormProps {
  onSubmit: (
    approved_at: Date,
    send_email: boolean,
    subject: LocaleString,
    message: LocaleString,
  ) => Promise<any>;
  onClose: () => Promise<void>;
}

const ApproveModalForm: FunctionComponent<ApproveModalFormProps> = ({
  onClose,
  onSubmit,
}) => {
  const user = useListUser();

  const schema = yup
    .object({
      approved_at: yup.date(),
      send_email: yup.boolean(),
      subject: yup.string().validateRequired(),
      message: yup.string().validateRequired(),
    })
    .required();

  const methods = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      approved_at: new Date(),
      send_email: true,
      subject: "",
      message: "",
    },
  });

  const handleSubmit = async (values: any) => {
    const { approved_at, send_email, subject, message } = values;
    onSubmit(approved_at, send_email, subject, message);
  };

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, text: "Tarkasta" },
  ];

  const email = methods.getValues()["send_email"] || false;

  if (!user) {
    return null;
  }

  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <Row>
          <Col>
            <Datepicker
              name="approved_at"
              label="Ilmoituksen hyväksymispäivämäärä"
              time
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Checkbox
              name="send_email"
              label="Lähetä sähköposti ilmoitusvelvolliselle"
            />
          </Col>
        </Row>
        <FormEmailRows
          disabled={email === false}
          allowImport
          prefill="approved"
          locale={user.locale}
        />
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default ApproveModalForm;
